import { ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getUser, setUserFromToken, hasPermission } from '@/store/userStore';
import { getSidebarState, getMobileSidebarState, toggleSidebar as storeToggleSidebar, closeMobileSidebar } from '@/store/uiStore';
import { PERMISSIONS } from '@/constants/permissions';
export default {
    name: 'Sidebar',
    setup() {
        const showMantenimiento = ref(false);
        const showGestion = ref(false);
        const showVentas = ref(false);
        const isCollapsed = getSidebarState();
        const isMobileOpen = getMobileSidebarState();
        const logoExists = ref(false);
        const router = useRouter();
        const user = ref(null);
        const route = useRoute();
        onMounted(() => {
            user.value = getUser();
            if (!user.value) {
                const token = localStorage.getItem('accessToken');
                if (token) {
                    setUserFromToken(token);
                    user.value = getUser();
                }
            }
        });
        // Wrapper para usar hasPermission limpiamente en el template
        function can(code) {
            return hasPermission(code);
        }
        function toggleGestion() {
            showGestion.value = !showGestion.value;
        }
        function toggleMantenimiento() {
            showMantenimiento.value = !showMantenimiento.value;
        }
        function toggleVentas() {
            showVentas.value = !showVentas.value;
        }
        function goTo(path) {
            router.push(path);
            if (isMobileOpen.value) {
                closeMobileSidebar();
            }
        }
        function isActive(path) {
            return route.path === path;
        }
        const gestionRoutes = [
            '/panel/gestion/aprobar-pagos',
            '/panel/gestion/pedidos',
            '/panel/gestion/historial-pagos'
        ];
        const mantenimientoRoutes = [
            '/panel/mantenimiento/repuestos',
            '/panel/mantenimiento/desplegables',
            '/panel/mantenimiento/equivalentes',
            '/panel/mantenimiento/departamentos',
            '/panel/mantenimiento/categorias',
            '/panel/mantenimiento/usuarios',
            '/panel/mantenimiento/roles',
            '/panel/mantenimiento/configuracion-sistema',
            '/panel/mantenimiento/instrumentos-pago',
            '/panel/mantenimiento/almacenes',
            '/panel/mantenimiento/red-aliada'
        ];
        const ventasRoutes = [
            '/panel/ventas-retail',
            '/panel/ventas-retail/comanda',
            '/panel/ventas-retail/caja',
            '/panel/ventas-retail/en-vivo',
            '/panel/notas-credito'
        ];
        const isInGestionSubmenu = computed(() => gestionRoutes.includes(route.path));
        const isInMantenimientoSubmenu = computed(() => mantenimientoRoutes.includes(route.path));
        const isInVentasSubmenu = computed(() => ventasRoutes.includes(route.path));
        if (isInGestionSubmenu.value)
            showGestion.value = true;
        if (isInMantenimientoSubmenu.value)
            showMantenimiento.value = true;
        if (isInVentasSubmenu.value)
            showVentas.value = true;
        function toggleCollapse() {
            storeToggleSidebar();
        }
        function closeMobile() {
            closeMobileSidebar();
        }
        return {
            P: PERMISSIONS,
            user,
            can,
            showMantenimiento,
            toggleMantenimiento,
            showGestion,
            toggleGestion,
            showVentas,
            toggleVentas,
            canSeeGestion: computed(() => can(PERMISSIONS.PAGOS.APPROVE) || can(PERMISSIONS.PEDIDOS.MANAGE) || can(PERMISSIONS.PAGOS.HISTORY)),
            canSeeVentas: computed(() => can(PERMISSIONS.VENTAS_RETAIL.VIEW) || can(PERMISSIONS.VENTAS_RETAIL.COMANDA) || can(PERMISSIONS.VENTAS_RETAIL.CAJA) || can(PERMISSIONS.NOTAS_CREDITO.VIEW)),
            canSeeAlmacenes: computed(() => can(PERMISSIONS.ALMACENES.VIEW) || can(PERMISSIONS.ALMACENES.TRASLADOS_VIEW)),
            canSeeMantenimiento: computed(() => can(PERMISSIONS.REPUESTOS.VIEW) ||
                can(PERMISSIONS.EQUIVALENTES.VIEW) ||
                can(PERMISSIONS.USUARIOS.VIEW) ||
                can(PERMISSIONS.ROLES.MANAGE) ||
                can(PERMISSIONS.CONFIGURACION.DESPLEGABLES_VIEW) ||
                can(PERMISSIONS.CONFIGURACION.DEPARTAMENTOS_VIEW) ||
                can(PERMISSIONS.CONFIGURACION.CATEGORIAS_VIEW) ||
                can(PERMISSIONS.CONFIGURACION.INSTRUMENTOS_PAGO_VIEW) ||
                can(PERMISSIONS.CONFIGURACION.SISTEMA_VIEW)),
            isInMantenimientoSubmenu,
            isInGestionSubmenu,
            isInVentasSubmenu,
            goTo,
            isActive,
            isCollapsed,
            toggleCollapse,
            isMobileOpen,
            closeMobile,
            logoExists
        };
    },
};
